export default "__VITE_ASSET__DUZFO0U8__"